/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Add_LinkInputs */



/**
* | output |
* | --- |
* | "Add link" |
*
* @param {Profile_Add_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_add_link = /** @type {((inputs?: Profile_Add_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Add_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir enlace")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi link")
	return /** @type {LocalizedString} */ ("Add link")
});